<div class="guided-vt-header">
  @if (currentState === 'high' || currentState === 'low') {
    <p class="guided-vt-header--text">{{ 'visualEventModal.option' | translate }}</p>
  }
  <!-- Extra element to keep close button aligned -->
  <div></div>
  <button mat-icon-button (click)="close()">
    <mat-icon svgIcon="icons-chevron-left"></mat-icon>
  </button>
</div>
<div
  class="ipm-mobile-bottom-sheet__guided-content"
  [ngClass]="{ 'ipm-mobile-bottom-sheet__guided-content--extended': currentState === 'form' }"
>
  @switch (currentState) {
    @case ('high') {
      @if (data.visualEventTypes) {
        <table class="ipm-mobile-bottom-sheet__guided-table" data-testid="ve-type-list">
          <tbody>
            @for (section of $any(data.visualEventTypes); track section; let i = $index) {
              <tr>
                <td class="ipm-mobile-bottom-sheet__guided-table-actions__name">{{ section.name }}</td>
                <td class="ipm-mobile-bottom-sheet__guided-table-actions">
                  <button
                    mat-flat-button
                    color="primary"
                    (click)="startSection(i)"
                    [disabled]="section.isSaving"
                    [ngClass]="{ 'update-button': section.completeCount > 0 }"
                  >
                    {{ (section.completeCount > 0 ? 'manageTaskModal.update' : 'visualEventModal.start') | translate }}
                  </button>
                  <button
                    mat-stroked-button
                    color="primary"
                    [disabled]="section.completeCount > 0"
                    (click)="markSectionNA(i)"
                    [ngClass]="{ 'osc-button--loading': section.isSaving, 've-count': section.completeCount > 0 }"
                  >
                    {{
                      section.completeCount === 0
                        ? ('visualEventModal.na' | translate)
                        : '(' + padLeft('' + section.completeCount, '0', 2) + '/' + padLeft('' + section.options.length, '0', 2) + ')'
                    }}
                  </button>
                </td>
              </tr>
            }
          </tbody>
        </table>
      }
    }
    @case ('low') {
      @if (currentVETypes) {
        <table class="ipm-mobile-bottom-sheet__guided-table">
          <tbody>
            @for (veType of currentVETypes; track veType; let i = $index) {
              <tr>
                <td>{{ veType.label }}</td>
                <td class="ipm-mobile-bottom-sheet__guided-table-actions">
                  <button
                    mat-flat-button
                    color="primary"
                    (click)="startVisualEvent(i)"
                    [disabled]="veType.isSaving"
                    [ngClass]="{ 'update-button': veType.isComplete > -1 }"
                  >
                    {{ (veType.isComplete > -1 ? 'manageTaskModal.update' : 'visualEventModal.start') | translate }}
                  </button>
                  @if (!(veType.isComplete > -1)) {
                    <button
                      mat-stroked-button
                      color="primary"
                      (click)="markVE_Na(i)"
                      [ngClass]="{ 'osc-button--loading': veType.isSaving }"
                    >
                      {{ 'visualEventModal.na' | translate }}
                    </button>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      }
    }
    @case ('form') {
      <ng-container [formGroup]="visualEventGuidedForm">
        <p>{{ currentVE.visualEventType }}</p>
        <app-selection-field
          formControlName="vEStatus"
          [field]="visualEventStatus"
          [data]="radioSelectionForVisualEventStatus"
          (changed)="saveVE()"
        ></app-selection-field>
        @if (isPriorityRequired) {
          <app-selection-field
            formControlName="vEPriorityCode"
            [field]="visualEventPriorityCode"
            [data]="radioSelectionForPriorityCode"
            (changed)="saveVE()"
          ></app-selection-field>
        }
        @if (visualEventStatus.value !== '') {
          <app-text-field [field]="visualEventNotes" [id]="visualEventNotesField" (changed)="setNotes($event)"></app-text-field>
        }
        @if (isPriorityRequired && visualEventStatus.value !== 'N/A') {
          <app-text-field
            [field]="visualEventRecommendation"
            [id]="visualEventRecommendationField"
            (changed)="setRecommendation($event)"
          ></app-text-field>
        }
        @if (visualEventStatus.value !== '' && visualEventStatus.value !== 'N/A') {
          <div class="ipm-field ipm-selection-field" (click)="assignLocation()">
            <div class="ipm-selection-field__container">
              <p class="ipm-field__label">{{ assignLocationLabel }}</p>
              <p class="ipm-field__value">
                {{
                  visualEventLocations.length > 0 || visualEventWholeEquipment
                    ? visualEventWholeEquipment
                      ? 'Entire Equipment'
                      : visualEventLocations.length + ' Assigned'
                    : '---'
                }}
              </p>
            </div>
            <mat-icon svgIcon="icons-chevron-right"></mat-icon>
          </div>
        }
        <p class="ipm-field__label ipm-mobile-bottom-sheet--adj">{{ pictureLabel }}</p>
        @if (visualEventStatus.value !== '' && visualEventStatus.value !== 'N/A') {
          <div class="ipm-manage-visual-event__images-container">
            <div class="ipm-manage-visual-event__image-add">
              <app-add-button [actions]="addPhotoActions" [leftAlign]="true"></app-add-button>
            </div>
            <div class="ipm-manage-visual-event__images-row">
              @for (image of currentVE.images; track image; let i = $index) {
                @if (image.imageUrl | offlineImage | async; as imageUrl) {
                  <div
                    class="ipm-manage-visual-event__image"
                    [attr.data-testId]="'image-' + i"
                    [ngStyle]="{ 'background-image': 'url(' + imageUrl + ')', 'background-position': 'center', 'background-size': 'cover' }"
                  >
                    <button
                      mat-mini-fab
                      class="ipm-manage-visual-event__image-delete"
                      role="button"
                      (click)="deleteImage(image.fileId)"
                      aria-label="Delete Image"
                    >
                      <mat-icon>link_off</mat-icon>
                    </button>
                    <button class="ipm-manage-visual-event__image-expand" (click)="expand(i)">
                      <mat-icon svgIcon="icon-expand"></mat-icon>
                    </button>
                  </div>
                }
              }
            </div>
          </div>
        }
      </ng-container>
    }
    @case ('location') {
      <div class="ipm-visual-event-modal__location">
        <button (click)="addNewVELocation()" [disabled]="currentVE.wholeEquipment" mat-flat-button color="primary">
          {{ 'manageUserModal.add' | translate }}
        </button>
        <mat-checkbox class="equipment-checkbox" labelPosition="before" [(ngModel)]="currentVE.wholeEquipment">
          {{ 'visualEventModal.wholeEquipment' | translate }}
        </mat-checkbox>
      </div>
    }
  }
</div>
<div class="ipm-mobile-bottom-sheet__guided-actions">
  @let isNavigationDisabled = isSaving || isPictureAddInProgress;
  <button
    mat-stroked-button
    color="primary"
    [disabled]="isNavigationDisabled"
    (click)="backClicked()"
    [ngClass]="{ 'd-none': !(currentState === 'form' || currentState === 'location') }"
  >
    {{ 'manageSignature.back' | translate }}
  </button>
  @if (currentState === 'form' || currentState === 'low') {
    <button mat-stroked-button color="primary" [disabled]="isNavigationDisabled" (click)="nextClicked()">
      {{ 'sendForReviewModal.' + (currentState === 'form' ? 'next' : 'done') | translate }}
    </button>
  }
</div>
